import {CommonModule} from '@angular/common';
import {ChangeDetectionStrategy, Component} from '@angular/core';
import {MatDialogModule} from '@angular/material/dialog';
import {TranslateModule} from '@ngx-translate/core';
import {PrimaryButtonComponent} from '@q9elements/ui-kit/components';

const BOOK_A_CALL_URL = 'https://elements.cloud/book-a-call/?step=1';

@Component({
  selector: 'app-change-monitoring-paywall',
  standalone: true,
  imports: [CommonModule, MatDialogModule, TranslateModule, PrimaryButtonComponent],
  templateUrl: './change-monitoring-paywall.component.html',
  styleUrls: ['./change-monitoring-paywall.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChangeMonitoringPaywallComponent {
  protected readonly features: ReadonlyArray<{titleKey: string; bodyKey: string}> = [
    {
      titleKey: 'CHANGE_MONITORING.PAYWALL_FEATURES.REALTIME_TITLE',
      bodyKey: 'CHANGE_MONITORING.PAYWALL_FEATURES.REALTIME_DESC'
    },
    {
      titleKey: 'CHANGE_MONITORING.PAYWALL_FEATURES.VISIBILITY_TITLE',
      bodyKey: 'CHANGE_MONITORING.PAYWALL_FEATURES.VISIBILITY_DESC'
    },
    {
      titleKey: 'CHANGE_MONITORING.PAYWALL_FEATURES.POLICIES_TITLE',
      bodyKey: 'CHANGE_MONITORING.PAYWALL_FEATURES.POLICIES_DESC'
    },
    {
      titleKey: 'CHANGE_MONITORING.PAYWALL_FEATURES.AUDIT_TITLE',
      bodyKey: 'CHANGE_MONITORING.PAYWALL_FEATURES.AUDIT_DESC'
    },
    {
      titleKey: 'CHANGE_MONITORING.PAYWALL_FEATURES.SETUP_TITLE',
      bodyKey: 'CHANGE_MONITORING.PAYWALL_FEATURES.SETUP_DESC'
    },
    {
      titleKey: 'CHANGE_MONITORING.PAYWALL_FEATURES.DELIVERY_TITLE',
      bodyKey: 'CHANGE_MONITORING.PAYWALL_FEATURES.DELIVERY_DESC'
    }
  ];

  public bookACall(): void {
    window.open(BOOK_A_CALL_URL, '_blank', 'noopener,noreferrer');
  }
}
